import axios from 'axios';

import CsrfToken from './csrf-token';

export const setCsrfToken = (config) => {
  config = _initializeConfig(config);
  config.headers['X-CSRF-TOKEN'] = CsrfToken.get();
  return config;
};

function _initializeConfig(config) {
  config = config || {};
  config.headers = config.headers || {};
  return config;
}

function _setMultipart(config) {
  config = _initializeConfig(config);
  config.headers['Content-Type'] = 'multipart/form-data';
  return config;
}

function _setNoCache(config) {
  config = _initializeConfig(config);
  config.headers['Cache-Control'] = 'no-cache';
  return config;
}

class Http {
  async delete(url, config = null) {
    config = setCsrfToken(config);
    config = _setMultipart(config);
    return await axios.delete(url, config);
  }

  async get(url, config = null, noCache = false) {
    if (noCache){
      config = _setNoCache(config);
    }

    return await axios.get(url, config);
  }

  async patch(url, data, config = null) {
    config = setCsrfToken(config);
    config = _setMultipart(config);
    return await axios.patch(url, data, config);
  }

  async post(url, data, config = null) {
    config = setCsrfToken(config);
    config = _setMultipart(config);
    return await axios.post(url, data, config);
  }

  async put(url, data, config = null) {
    config = setCsrfToken(config);
    config = _setMultipart(config);
    return await axios.put(url, data, config);
  }
}

export default new Http();
